/* eslint-disable react-hooks/exhaustive-deps */
import {Remove} from 'components/grid-dx/consult-buttons';
import {useGetToken} from 'components/hooks';
import {Column} from 'devextreme-react/data-grid';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import IntegrityRoleGrid from '../../../../../components/UserRole';
import {i18n2} from '../../../../i18n/i18n';
import {getProfCourse, useGetProfiles} from '../../hooks/index';
import {
  REMOVE_PROFILE_SPAC,
  SELECT_ALL_PROFILES,
  SET_PROFILE,
} from '../../types';
import {getProfCourseWithoutAdditional} from './../../hooks/useLoadProfCourseWithAdditional';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

const Buttons = ({data}: any) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <Remove row={data} type={REMOVE_PROFILE_SPAC} />
    </div>
  );
};

const SelectedProfilesGrid = (props: any) => {
  const {selectAll, setSelectAll} = props;
  const isTablet = useIsTablet();
  const dispatch = useDispatch();
  const token = useGetToken();
  const profiles = useGetProfiles();
  const filters = useSelector((state: any) => state.gridReducer.filters);

  useEffect(() => {
    if (selectAll) {
      getProfCourseWithoutAdditional(filters, token).then(({data}: any) => {
        setAllProfiles(data);
      });
      setSelectAll(false);
    }
  }, [selectAll]);

  useEffect(() => {
    const additional = JSON.stringify({
      Value: props.id,
    });
    getProfCourse(additional, token).then(({data}: any) => {
      setProfiles(data);
    });
  }, []);

  const setProfiles = (data: any) => {
    dispatch({type: SET_PROFILE, payload: data});
  };

  const setAllProfiles = (data: any) => {
    dispatch({type: SELECT_ALL_PROFILES, payload: data});
  };

  return (
    <IntegrityRoleGrid
      dataSource={profiles}
      allowActions={false}
      allowExport={false}
      allowIntegrity={false}
      width="600px"
      height="70vh"
      id={['iD_ProfileSpac']}>
      <Column
        caption={i18n2._('#ProfileSpac')}
        dataField="iD_ProfileSpac"
        visible={false}
      />
      <Column caption={i18n2._('Perfil Spac')} dataField="name_ProfSpac" />
      <Column caption={i18n2._('Nombre del SPAC')} dataField="name_Spac" />
      <Column
        caption=""
        cellComponent={(e: any) => <Buttons data={e.data.data} />}
        width={getActionColumnWidth(1, isTablet)}
        fixed
        alignment="right"
      />
    </IntegrityRoleGrid>
  );
};

export default SelectedProfilesGrid;
